import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import BookingCategoryListPage from './BookingCategoryList';
import BookingCategoryModalPage from './BookingCategoryModal';
import './BookingCategory.css';

@inject(
    'loginStore',
    'BookingCategoryStore'
)
@observer
class BookingCategoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });    
    }

    // ON CANCEL

    bookingCategoryModalOnCancel = () => {
        this.props.BookingCategoryStore.setShowBookingCategoryModal(false);
    }

    render() {
        const {
            showBookingCategoryModal,
            bookingCategoryTitle,
        } = this.props.BookingCategoryStore;

        return (
            <MainContainer title='Booking Category' menukey='booking-category'>
                <Modal
                    title={bookingCategoryTitle}
                    visible={showBookingCategoryModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingCategoryModalOnCancel}
                    zIndex={1000}
                >
                    <BookingCategoryModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <BookingCategoryListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default BookingCategoryPage;
